import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import CreateEditContent from './CreateEditContent';
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { Colors } from '~/config/Colors';
import {
  SLEditModal,
  SLCreateModal,
} from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';
import ScriptTag from 'react-script-tag';

export default function Gantt() {
  const [data, setData] = useState([]);
  const [loadedData, setLoadedData] = useState(false);
  const [previsaoInicio, setPrevisaoInicio] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [previsaoFinal, setPrevisaoFinal] = useState(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
  const [idCliente, setIdCliente] = useState();
  const [idEtapa, setIdEtapa] = useState();
  const [idAnalista, setIdAnalista] = useState();
  const [tipoGantt, setTipoGantt] = useState("A");
  const { perfil } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil, previsaoInicio, previsaoFinal, tipoGantt]);

  useEffect(() => {
    api.get(
      '/signed/empresa/gestorprojeto/gantts',
      {
        params: { dataPrevInicio: previsaoInicio, dataPrevFinal: previsaoFinal, tipo: tipoGantt, idCliente, idEtapa, idAnalista }
      }
    ).then(r => setData(r?.data));
  }, [previsaoInicio, previsaoFinal, tipoGantt, idCliente, idEtapa, idAnalista]);

  // findAll: () =>
  //   api.get('/signed/empresa/gestorprojeto/gantts', {
  //     params: { dataPrevInicio: previsaoInicio, dataPrevFinal: previsaoFinal, tipo: tipoGantt },
  //   }),
  //   findOne: thisData =>
  //     api.get('/signed/empresa/gestorprojeto/cliente/cliente', {
  //       params: { id: thisData.id },
  //     }),
  //     deleteOne: thisData =>
  //       api.delete('/signed/empresa/gestorprojeto/cliente/cliente', {
  //         data: { id: thisData.id },
  //       }),
  return (
    <Main>
      <LandPage>
        <div className="content">
          <CustomBodyContent {...{
            data,
            previsaoInicio,
            setPrevisaoInicio,
            previsaoFinal,
            setPrevisaoFinal,
            tipoGantt,
            setTipoGantt,
            idCliente,
            setIdCliente,
            idEtapa,
            setIdEtapa,
            idAnalista,
            setIdAnalista,
          }} />
        </div>
      </LandPage>
    </Main>
  );
}
